import React from "react";
import './Business.css';

class Business extends React.Component {
  render() {
    return (
      <div className="Business">
        <div className="image-container">
          <img src={ this.props.business.imageSrc } alt={ this.props.business.name } />
        </div>

        <div className="subhead">
          <div>
            <h3>{ this.props.business.price }</h3>
          </div>

          <div>
            <h3>{ this.props.business.name }</h3>
          </div>

        </div>

        <div className="Business-information">
          <div className="Business-address">
            <p>{ this.props.business.address }</p>
            <p>{ this.props.business.city }, </p>
            <p>{ this.props.business.province } { this.props.business.zipCode }</p>
     
          </div>
          
          <div className="Business-reviews">
            <p>{ this.props.business.category }</p>
            <p className="rating">{ this.props.business.rating } <i class="fa fa-star"></i></p>
            <p>{ this.props.business.reviewCount } reviews</p>
            
          </div>
        </div>
      </div>
    );
  }
}

export default Business;